require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./product-new-zealand-greenshell-mussels.json") })
        }
      }, "path---product-new-zealand-greenshell-mussels");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---product-new-zealand-greenshell-mussels!./.cache/json/product-new-zealand-greenshell-mussels.json
// module id = 526
// module chunks = 231608221292675